import { render } from "./TreatmentsPage.vue?vue&type=template&id=62dee4f9&scoped=true"
import script from "./TreatmentsPage.vue?vue&type=script&lang=js"
export * from "./TreatmentsPage.vue?vue&type=script&lang=js"

import "./TreatmentsPage.vue?vue&type=style&index=0&id=62dee4f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dee4f9"]])

export default __exports__